// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditWishListGroupForm-errorMessage-q4vwA {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.EditWishListGroupForm-space1-G1hNX {
	margin-bottom: 6px !important;
}
.EditWishListGroupForm-space2-nmUZ0 {
	margin-bottom: 12px !important;
}
.EditWishListGroupForm-space3-b9yIr {
	margin-bottom: 18px !important;
}
.EditWishListGroupForm-space4-uqfGm {
	margin-bottom: 24px !important;
}
.EditWishListGroupForm-space5-qagWz {
	margin-bottom: 30px !important;
}
.EditWishListGroupForm-space6-ibDpL {
	margin-bottom: 36px !important;
}
.EditWishListGroupForm-space7-vFlJ0 {
	margin-bottom: 42px !important;
}
.EditWishListGroupForm-spaceTop8-l6zRQ {
	margin-bottom: 48px !important;
}
.EditWishListGroupForm-spaceTop1-xgRYh {
	margin-top: 6px !important;
}
.EditWishListGroupForm-spaceTop2-JtYoz {
	margin-top: 12px !important;
}
.EditWishListGroupForm-spaceTop3-JNQI7 {
	margin-top: 18px !important;
}
.EditWishListGroupForm-spaceTop4-ot6hf {
	margin-top: 24px !important;
}
.EditWishListGroupForm-spaceTop5-j14z4 {
	margin-top: 30px !important;
}
.EditWishListGroupForm-spaceTop6-WKRZB {
	margin-top: 36px !important;
}
.EditWishListGroupForm-spaceTop7-CcNNl {
	margin-top: 42px !important;
}
.EditWishListGroupForm-spaceTop8-l6zRQ {
	margin-top: 48px !important;
}
.EditWishListGroupForm-noMargin-MxrwV {
	margin: 0px !important;
}
.EditWishListGroupForm-padding1-xp1MT {
	padding-bottom: 6px !important;
}
.EditWishListGroupForm-padding2-HYn4K {
	padding-bottom: 12px !important;
}
.EditWishListGroupForm-padding3-WG822 {
	padding-bottom: 18px !important;
}
.EditWishListGroupForm-padding4-SgoWh {
	padding-bottom: 24px !important;
}
.EditWishListGroupForm-padding5-S2b_v {
	padding-bottom: 30px !important;
}
.EditWishListGroupForm-padding6-DaVNL {
	padding-bottom: 36px !important;
}
.EditWishListGroupForm-padding7-f3hvH {
	padding-bottom: 42px !important;
}
.EditWishListGroupForm-paddingTop1-ifQRQ {
	padding-top: 6px !important;
}
.EditWishListGroupForm-paddingTop2-oi4eh {
	padding-top: 12px !important;
}
.EditWishListGroupForm-paddingTop3-OdYm1 {
	padding-top: 18px !important;
}
.EditWishListGroupForm-paddingTop4-dXxOO {
	padding-top: 24px !important;
}
.EditWishListGroupForm-paddingTop5-uxf3Y {
	padding-top: 30px !important;
}
.EditWishListGroupForm-paddingTop6-Kjt9j {
	padding-top: 36px !important;
}
.EditWishListGroupForm-paddingTop7-TU8dR {
	padding-top: 42px !important;
}
.EditWishListGroupForm-noPadding-ZWgHJ {
	padding: 0px !important;
}
.EditWishListGroupForm-textBold-SFYuk {
	font-weight: 500 !important;
}
.EditWishListGroupForm-textBolder-nFmmj {
	font-weight: 700 !important;
}
.EditWishListGroupForm-textNormal-EnJTU {
	font-weight: normal !important;
}
.EditWishListGroupForm-spaceBottom20-rYiXG {
	margin-bottom: 20px;
}
.EditWishListGroupForm-spaceBottom10-BhSDo {
	margin-bottom: 10px;
}
.EditWishListGroupForm-marginNone-YPGkc {
	margin: 0;
}
.EditWishListGroupForm-spaceBottom15-ifxDi {
	margin-bottom: 15px;
}
.EditWishListGroupForm-marginTopNone-rbldH {
	margin-top: 0;
}
.EditWishListGroupForm-spaceTop11-WVldu {
	margin-top: 11px;
}
.EditWishListGroupForm-spaceTop21-LV2ZZ {
	margin-top: 21px;
}
.EditWishListGroupForm-spaceTop20-tdmZv {
	margin-top: 20px;
}
.EditWishListGroupForm-spaceTop10-gIFOd {
	margin-top: 10px;
}
/*New Design Text Colors */
.EditWishListGroupForm-textDarkBlue-hc9la {
	color: rgb(20, 39, 94) !important;
}
.EditWishListGroupForm-textLightBlue-I8pVq {
	color: rgb(57, 87, 106) !important;
}
.EditWishListGroupForm-textLightSandleGreen-bAG2z {
	color: rgb(76, 86, 41) !important;
}
.EditWishListGroupForm-textLightBrown-Jg_z1 {
	color: rgb(115, 79, 33) !important;
}
.EditWishListGroupForm-textMediumMaroon-xHOR8 {
	color: rgb(87, 37, 51) !important;
}
.EditWishListGroupForm-textBrown-nEjHS {
	color: rgb(160, 47, 24) !important;
}
.EditWishListGroupForm-textMaroon-Kh_vJ {
	color: rgb(155, 49, 67) !important;
}
.EditWishListGroupForm-textDarkBrown-ZetXd {
	color: rgb(83, 18, 16) !important;
}
.EditWishListGroupForm-textMediumBrown-IHEjV {
	color: rgb(142, 28, 10) !important;
}
.EditWishListGroupForm-textSkyBlue-jpbBc {
	color: rgb(37, 117, 141) !important;
}
.EditWishListGroupForm-textGray-OmNck {
	color: rgb(77, 65, 51) !important;
}
/** RentAll - Begin **/
.EditWishListGroupForm-formGroup-l971m {
  margin-bottom: 6px !important;
}
.EditWishListGroupForm-labelText-aWTk7 {
  font-size: 15px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
}
.EditWishListGroupForm-cancelBtn-sg8Rp {
  color: var(--primary-link-foreground) !important;
  margin-right: 30px;
  font-size: 16px;
  text-decoration: none !important;
  cursor: pointer;
}
.EditWishListGroupForm-alignRight-ZOJlR {
  text-align: right;
  margin-top: 19px;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/WishLists/EditWishListGroupForm/EditWishListGroupForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA,sBAAsB;AACtB;EACE,6BAA6B;AAC/B;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../utils.css';\n@import '../../helpers.css';\n\n/** RentAll - Begin **/\n.formGroup {\n  margin-bottom: 6px !important;\n}\n\n.labelText {\n  font-size: 15px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n}\n\n.cancelBtn {\n  color: var(--primary-link-foreground) !important;\n  margin-right: 30px;\n  font-size: 16px;\n  text-decoration: none !important;\n  cursor: pointer;\n}\n\n.alignRight {\n  text-align: right;\n  margin-top: 19px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `EditWishListGroupForm-errorMessage-q4vwA`,
	"space1": `EditWishListGroupForm-space1-G1hNX`,
	"space2": `EditWishListGroupForm-space2-nmUZ0`,
	"space3": `EditWishListGroupForm-space3-b9yIr`,
	"space4": `EditWishListGroupForm-space4-uqfGm`,
	"space5": `EditWishListGroupForm-space5-qagWz`,
	"space6": `EditWishListGroupForm-space6-ibDpL`,
	"space7": `EditWishListGroupForm-space7-vFlJ0`,
	"spaceTop8": `EditWishListGroupForm-spaceTop8-l6zRQ`,
	"spaceTop1": `EditWishListGroupForm-spaceTop1-xgRYh`,
	"spaceTop2": `EditWishListGroupForm-spaceTop2-JtYoz`,
	"spaceTop3": `EditWishListGroupForm-spaceTop3-JNQI7`,
	"spaceTop4": `EditWishListGroupForm-spaceTop4-ot6hf`,
	"spaceTop5": `EditWishListGroupForm-spaceTop5-j14z4`,
	"spaceTop6": `EditWishListGroupForm-spaceTop6-WKRZB`,
	"spaceTop7": `EditWishListGroupForm-spaceTop7-CcNNl`,
	"noMargin": `EditWishListGroupForm-noMargin-MxrwV`,
	"padding1": `EditWishListGroupForm-padding1-xp1MT`,
	"padding2": `EditWishListGroupForm-padding2-HYn4K`,
	"padding3": `EditWishListGroupForm-padding3-WG822`,
	"padding4": `EditWishListGroupForm-padding4-SgoWh`,
	"padding5": `EditWishListGroupForm-padding5-S2b_v`,
	"padding6": `EditWishListGroupForm-padding6-DaVNL`,
	"padding7": `EditWishListGroupForm-padding7-f3hvH`,
	"paddingTop1": `EditWishListGroupForm-paddingTop1-ifQRQ`,
	"paddingTop2": `EditWishListGroupForm-paddingTop2-oi4eh`,
	"paddingTop3": `EditWishListGroupForm-paddingTop3-OdYm1`,
	"paddingTop4": `EditWishListGroupForm-paddingTop4-dXxOO`,
	"paddingTop5": `EditWishListGroupForm-paddingTop5-uxf3Y`,
	"paddingTop6": `EditWishListGroupForm-paddingTop6-Kjt9j`,
	"paddingTop7": `EditWishListGroupForm-paddingTop7-TU8dR`,
	"noPadding": `EditWishListGroupForm-noPadding-ZWgHJ`,
	"textBold": `EditWishListGroupForm-textBold-SFYuk`,
	"textBolder": `EditWishListGroupForm-textBolder-nFmmj`,
	"textNormal": `EditWishListGroupForm-textNormal-EnJTU`,
	"spaceBottom20": `EditWishListGroupForm-spaceBottom20-rYiXG`,
	"spaceBottom10": `EditWishListGroupForm-spaceBottom10-BhSDo`,
	"marginNone": `EditWishListGroupForm-marginNone-YPGkc`,
	"spaceBottom15": `EditWishListGroupForm-spaceBottom15-ifxDi`,
	"marginTopNone": `EditWishListGroupForm-marginTopNone-rbldH`,
	"spaceTop11": `EditWishListGroupForm-spaceTop11-WVldu`,
	"spaceTop21": `EditWishListGroupForm-spaceTop21-LV2ZZ`,
	"spaceTop20": `EditWishListGroupForm-spaceTop20-tdmZv`,
	"spaceTop10": `EditWishListGroupForm-spaceTop10-gIFOd`,
	"textDarkBlue": `EditWishListGroupForm-textDarkBlue-hc9la`,
	"textLightBlue": `EditWishListGroupForm-textLightBlue-I8pVq`,
	"textLightSandleGreen": `EditWishListGroupForm-textLightSandleGreen-bAG2z`,
	"textLightBrown": `EditWishListGroupForm-textLightBrown-Jg_z1`,
	"textMediumMaroon": `EditWishListGroupForm-textMediumMaroon-xHOR8`,
	"textBrown": `EditWishListGroupForm-textBrown-nEjHS`,
	"textMaroon": `EditWishListGroupForm-textMaroon-Kh_vJ`,
	"textDarkBrown": `EditWishListGroupForm-textDarkBrown-ZetXd`,
	"textMediumBrown": `EditWishListGroupForm-textMediumBrown-IHEjV`,
	"textSkyBlue": `EditWishListGroupForm-textSkyBlue-jpbBc`,
	"textGray": `EditWishListGroupForm-textGray-OmNck`,
	"formGroup": `EditWishListGroupForm-formGroup-l971m`,
	"labelText": `EditWishListGroupForm-labelText-aWTk7`,
	"cancelBtn": `EditWishListGroupForm-cancelBtn-sg8Rp`,
	"alignRight": `EditWishListGroupForm-alignRight-ZOJlR`
};
module.exports = ___CSS_LOADER_EXPORT___;
